import { WithTooltip } from "./with_tooltip";

export function InfoTooltip(props: {
	info: JSX.Element | string;
	label?: JSX.Element | string;
}) {
	return (
		<WithTooltip tooltip={<span>{props.info}</span>} style="Info">
			<div className="flex items-center gap-1">
				{props.label && <span>{props.label}</span>}
				<i className="fa fa-info-circle fa-xs"></i>
			</div>
		</WithTooltip>
	);
}
